import { useFragment } from 'react-relay-offline'
import { useIntl } from 'react-intl'
import React from 'react'
import { useDrawer } from '@/ui/components'

import { ProductDetailsSectionItem } from '../ProductDetails'
import {
  ProductSpecificationsDrawer,
  productSpecificationsFragment,
} from './ProductSpecificationsDrawer'
import type { ProductSpecificationsDrawer_Product$key } from './__generated__/ProductSpecificationsDrawer_Product.graphql'

type ProductSpecificationsProps = {
  productSpecifications: ProductSpecificationsDrawer_Product$key | null
}

export const ProductSpecifications = ({
  productSpecifications,
}: ProductSpecificationsProps) => {
  const { formatMessage } = useIntl()

  const specificationsData = useFragment(
    productSpecificationsFragment,
    productSpecifications
  )

  const hasProductSpecifications = !!specificationsData?.specificationGroups
    ?.edges.length

  const productSpecificationssDrawer = useDrawer({
    route: '#/product-specifications-drawer',
  })

  if (
    specificationsData?.specificationGroups === undefined ||
    !hasProductSpecifications
  ) {
    return null
  }

  return (
    <>
      <ProductDetailsSectionItem
        onClick={() => productSpecificationssDrawer.open()}
        title={formatMessage({ id: 'productSpecificationsDrawerTitle' })}
      />
      <ProductSpecificationsDrawer
        isOpen={productSpecificationssDrawer.isOpen}
        onClose={() => productSpecificationssDrawer.onClose()}
        productSpecifications={productSpecifications}
      />
    </>
  )
}
